module.exports = __webpack_public_path__ + "img/saputo2022.f4abc688.jpg";